module.exports = __webpack_public_path__ + "static/customer-success-556b22834a7a9be9493a6ae4dd3e7470.png";